var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "wallet_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#wallet_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68 6.36 14.445 2.6a1.75 1.75 0 0 1 2.328 1.651v3.246h1.481c.966 0 1.75.783 1.75 1.75v2.268c.848.121 1.5.85 1.5 1.732v2a1.75 1.75 0 0 1-1.5 1.732v2.768a1.75 1.75 0 0 1-1.75 1.75h-14a1.75 1.75 0 0 1-1.75-1.75v-10.5c0-1.018-.136-2.428 1.176-2.886Zm1.296 1.137h10.297V4.251a.25.25 0 0 0-.333-.236L4.976 7.497Zm-.722 1.5a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25v-2.75h-2.75a2.75 2.75 0 0 1 0-5.5h2.75v-2.25a.25.25 0 0 0-.25-.25h-14Zm11.5 4a1.25 1.25 0 0 0 0 2.5h4a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25h-4Z",
    fill: "currentColor"
  }))));
};
export default SvgWallet;